import VideosListScreen from './VideosList';

export default VideosListScreen;
